export enum SignInStep {
  SignIn = 'SignIn',
  ForgotPassword = 'ForgotPassword',
  EnterConfirmationCode = 'EnterConfirmationCode',
  CreateAccount = 'CreateAccount',
  SentResetPasswordLink = 'SentResetPasswordLink',
  NotFoundContact = 'NotFoundContact',
  IdentityVerification = 'IdentityVerification',
  PrequalOtpVerification = 'PrequalOtpVerification',
  ResumeProcessOtpVerification = 'ResumeProcessOtpVerification',
}
